'use client';
import { useState, useEffect } from 'react';

export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0) setProgress(Math.min((scrollTop / docHeight) * 100, 100));
    };
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  if (progress < 1) return null;

  return (
    <>
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        height: 3, background: 'rgba(37,99,235,0.08)', pointerEvents: 'none',
      }}>
        <div style={{
          height: '100%', width: `${progress}%`,
          background: 'linear-gradient(90deg, var(--brand), var(--accent-green))',
          transition: 'width 0.1s linear',
          borderRadius: '0 2px 2px 0',
        }} />
      </div>
      {progress > 10 && progress < 98 && (
        <div className="kd-read-pct" data-rd="label" style={{
          /* ㉑a §2(a) — top:8 이면 sticky 마스트(.kd-mast) 위에 겹쳤다(운영 43×26 @scrolled). 헤더 아래로 내린다. */
          position: 'fixed', top: 'calc(var(--kd-header-bottom, 45px) + 8px)', right: 12, zIndex: 99,
          fontSize: 'var(--fs-2xs)', fontWeight: 'var(--fw-title)', color: 'var(--text-tertiary)',
          background: 'var(--bg-elevated)', padding: '3px 8px',
          borderRadius: 'var(--radius-md)', border: '1px solid var(--border)',
          pointerEvents: 'none',
          fontVariantNumeric: 'tabular-nums',
        }}>
          {Math.round(progress)}%
        </div>
      )}
    </>
  );
}
